<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { RotateCcw } from 'lucide-svelte';

  import { resetDialog } from '$lib/stores/ui';

  /**
   * The way out of a selection.
   *
   * # Why it exists
   *
   * Every other control narrows. Somebody who has been round the assistant, or
   * has a selection they no longer want, had no way back to the beginning
   * except reloading the page — and a customer who reloads to escape a screen
   * has been abandoned by it.
   *
   * # Why it is tinted red, and now also asks
   *
   * It throws work away. Nothing else in the bar does, so it should not look
   * like the things beside it; the tint says "this closes something" before it
   * is pressed.
   *
   * The tint used to be the whole warning, which was a fair trade while the
   * worst case was retyping some filters. A reset now also deletes the
   * customer's uploaded list — a file they had to find and minutes of matching
   * they had to wait for — and that is too much to lose to a misplaced click.
   * So the tint keeps its job of saying what kind of button this is, and the
   * dialog does the asking.
   *
   * The dialog itself lives in the layout, because it is positioned against the
   * working area rather than against this button.
   */

  function askToStartOver() {
    resetDialog.set({ show: true });
  }
</script>

<!--
  Red on navy rather than red on white. The pale wash this used to wear
  disappeared into a light bar and would now be the brightest thing on a dark
  one; translucent over the navy, it still reads as the destructive control
  without shouting across the bar.
-->
<button
  type="button"
  on:click={askToStartOver}
  title={$_('selection.startOver')}
  class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-control border border-red-400/40 bg-red-500/15 text-red-200 transition-colors hover:border-red-400/60 hover:bg-red-500/25 hover:text-red-100"
>
  <RotateCcw class="h-4 w-4" />
  <span class="sr-only">{$_('selection.startOver')}</span>
</button>
